/* eslint-disable no-nested-ternary */

import React, { useEffect } from 'react';
import { upperFirst, camelCase, kebabCase, lowerCase } from 'lodash';
import { useParams, useHistory } from 'react-router-dom';
import { NotFound, Loading, Error } from '@cordata/buffet';
import { toast } from 'react-toastify';

import * as Forms from '~/components/Ext';
import { useExt } from '~/utils';

const ExtSwitch = () => {
  const { type, externalActionInstance } = useParams();
  const history = useHistory();
  const { status, eai } = useExt();

  const bad = () => {
    toast.error('No registration found ...');

    history.replace(`/ext/${externalActionInstance}/register`);
  };

  const good = () => {
    toast.info('Registration found ...');

    history.replace(`/ext/${externalActionInstance}/${kebabCase(eai.actionName.name)}`);
  };

  useEffect(() => {
    if (type) {
      if (!type.includes('register') && status === 'invalid') {
        bad();
      } else if (type.includes('register') && status === 'valid') {
        good();
      }
    } else if (status === 'invalid') {
      bad();
    } else if (status === 'valid') {
      good();
    }
  }, [status]);

  const Form = Forms[upperFirst(camelCase(type))];

  return Form
    ? <Form />
    : status === 'loading'
      ? <Loading />
      : status === 'error'
        ? <Error />
        : <NotFound message={`${upperFirst(lowerCase(type))} form not found`} />;
};

export default ExtSwitch;
